// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  ======================

    - *** NOTICE ***
    - This file will be imported into lots of pages and components and needs to be kept as lean as possible
    - *** NOTICE ***

    - Transition docs:
    - As button types are built in the React repo using pre-existing styles, on an as needed basis...
    - > port the CSS selectors over from the legacy UX repo's pattern.button.css file
    - Put the code in the appropriate section for maintainability
    - Modify any kabob-cased classnames to camelCased
    - Change any hex color value(#1976d2) to use the correct color variable(var(--color-blue-primary))
    - In the UX repo, many times there are duplicate slectors in the same file, search for duplicates and merge them together...
    - > remember in CSS, the last declaration wins, so if there's conflicting declarations inside of duplicate selector blocks, use the last one in the file

    ====================== */

/* Base Button */
.Button_btn__g8LLk {
    margin: 0;
    border: none;
    border-radius: 4px;
    color: white;
    transition: background-color 200ms, border 100ms, box-shadow 100ms;
    cursor: pointer;
}
.Button_btn__g8LLk:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px white, 0 0 0 4px var(--color-blue-primary);
}

/* Disabled Button */
.Button_btn__g8LLk[disabled],
.Button_btn__g8LLk[disabled]:hover,
.Button_btn__g8LLk[disabled]:focus {
    cursor: not-allowed;
    box-shadow: none;
    opacity: .5;
}

/* Button SIZES */
.Button_btn__g8LLk.Button_btnLarge__q05Ln {
    height: 44px;
    padding: 0 25px;
    font-size: 16px;
    line-height: 22px;
}
.Button_btn__g8LLk.Button_btnMedium__Icah- {
    height: 33px;
    padding: 0 15px;
    font-size: 14px;
    line-height: 27px;
}
.Button_btn__g8LLk.Button_btnSmall__J8IWB {
    height: 22px;
    padding: 0 12px;
    font-size: 11px;
    line-height: 20px;
}


/* Primary Button */
.Button_btn__g8LLk.Button_btnPrimary__1NpC1,
.Button_btn__g8LLk.Button_btnPrimary__1NpC1[disabled]:hover,
.Button_btn__g8LLk.Button_btnPrimary__1NpC1[disabled]:focus {
    background-color: var(--color-blue-primary);
}
.Button_btn__g8LLk.Button_btnPrimary__1NpC1:hover  { background-color: var(--color-blue-dark-1); }
.Button_btn__g8LLk.Button_btnPrimary__1NpC1:focus  { background-color: var(--color-blue-primary); }
.Button_btn__g8LLk.Button_btnPrimary__1NpC1:active { background-color: var(--color-blue-dark-2); }


/* Secondary Button */
.Button_btn__g8LLk.Button_btnSecondary__s33fj,
.Button_btn__g8LLk.Button_btnSecondary__s33fj[disabled]:hover,
.Button_btn__g8LLk.Button_btnSecondary__s33fj[disabled]:focus {
    background-color: var(--color-darkui-accent-2);
}
.Button_btn__g8LLk.Button_btnSecondary__s33fj:hover  { background-color: var(--color-darkui-accent-1); }
.Button_btn__g8LLk.Button_btnSecondary__s33fj:focus  { background-color: var(--color-darkui-accent-2); }
.Button_btn__g8LLk.Button_btnSecondary__s33fj:active { background-color: var(--color-darkui-surface-4); }


/* Danger Button */
.Button_btn__g8LLk.Button_btnDanger__137s7,
.Button_btn__g8LLk.Button_btnDanger__137s7[disabled]:hover,
.Button_btn__g8LLk.Button_btnDanger__137s7[disabled]:focus {
    background-color: var(--color-red-primary);
}
.Button_btn__g8LLk.Button_btnDanger__137s7:hover  { background-color: var(--color-red-dark-1); }
.Button_btn__g8LLk.Button_btnDanger__137s7:focus  { background-color: var(--color-red-primary); }
.Button_btn__g8LLk.Button_btnDanger__137s7:active { background-color: var(--color-red-dark-2); }


/* Reverse Button */
.Button_btn__g8LLk.Button_btnReverse__9g22b,
.Button_btn__g8LLk.Button_btnReverse__9g22b[disabled]:hover,
.Button_btn__g8LLk.Button_btnReverse__9g22b[disabled]:focus {
  color: black;
  background-color: white;
}
.Button_btn__g8LLk.Button_btnReverse__9g22b:hover  { background-color: var(--color-lightui-surface-2); }
.Button_btn__g8LLk.Button_btnReverse__9g22b:focus  { background-color: white; }
.Button_btn__g8LLk.Button_btnReverse__9g22b:active { background-color: var(--color-lightui-surface-4); }


/* Buttons with Icon */
.Button_btn__g8LLk [class*="icon-"],
.Button_btn__g8LLk [class^="icon-"]  { vertical-align: unset; }

/* ICON-only Buttons */
.Button_btn__g8LLk.Button_icon__mwAN9           { padding: 0 10px; }
.Button_btn__g8LLk.Button_btnLarge__q05Ln.Button_icon__mwAN9  { padding: 0 15px; }
.Button_btn__g8LLk.Button_btnMedium__Icah-.Button_icon__mwAN9 { padding: 0 10px; }
.Button_btn__g8LLk.Button_btnSmall__J8IWB.Button_icon__mwAN9  { padding: 0 5px; font-size: 14px; }

/* Reverse Icon-only Buttons */
.Button_btn__g8LLk.Button_btnReverse__9g22b.Button_icon__mwAN9:active,
.Button_btn__g8LLk.Button_btnReverse__9g22b.Button_icon__mwAN9:hover { text-decoration: none; }


/* Miscellaneous Other */
.Button_btn__g8LLk.Button_block__RTXXp {
    width: 100%;
}
.Button_btn__g8LLk.Button_btnFlat__tUW3y {
    box-shadow: none;
    border-radius: 2px;
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Button/Button.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;4BAe4B;;AAE5B,gBAAgB;AAChB;IACI,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kEAAkE;IAClE,eAAe;AACnB;AACA;IACI,aAAa;IACb,gEAAgE;AACpE;;AAEA,oBAAoB;AACpB;;;IAGI,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;;AAEA,iBAAiB;AACjB;IACI,YAAY;IACZ,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;;;AAGA,mBAAmB;AACnB;;;IAGI,2CAA2C;AAC/C;AACA,qDAAyB,0CAA0C,EAAE;AACrE,qDAAyB,2CAA2C,EAAE;AACtE,qDAAyB,0CAA0C,EAAE;;;AAGrE,qBAAqB;AACrB;;;IAGI,8CAA8C;AAClD;AACA,uDAA2B,8CAA8C,EAAE;AAC3E,uDAA2B,8CAA8C,EAAE;AAC3E,uDAA2B,+CAA+C,EAAE;;;AAG5E,kBAAkB;AAClB;;;IAGI,0CAA0C;AAC9C;AACA,oDAAwB,yCAAyC,EAAE;AACnE,oDAAwB,0CAA0C,EAAE;AACpE,oDAAwB,yCAAyC,EAAE;;;AAGnE,mBAAmB;AACnB;;;EAGE,YAAY;EACZ,uBAAuB;AACzB;AACA,qDAAyB,gDAAgD,EAAE;AAC3E,qDAAyB,uBAAuB,EAAE;AAClD,qDAAyB,gDAAgD,EAAE;;;AAG3E,sBAAsB;AACtB;uCACyB,qBAAqB,EAAE;;AAEhD,sBAAsB;AACtB,kDAAsB,eAAe,EAAE;AACvC,gEAAsB,eAAe,EAAE;AACvC,gEAAsB,eAAe,EAAE;AACvC,gEAAsB,cAAc,EAAE,eAAe,EAAE;;AAEvD,8BAA8B;AAC9B;uEAC6B,qBAAqB,EAAE;;;AAGpD,wBAAwB;AACxB;IACI,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB","sourcesContent":["/*  ======================\n\n    - *** NOTICE ***\n    - This file will be imported into lots of pages and components and needs to be kept as lean as possible\n    - *** NOTICE ***\n\n    - Transition docs:\n    - As button types are built in the React repo using pre-existing styles, on an as needed basis...\n    - > port the CSS selectors over from the legacy UX repo's pattern.button.css file\n    - Put the code in the appropriate section for maintainability\n    - Modify any kabob-cased classnames to camelCased\n    - Change any hex color value(#1976d2) to use the correct color variable(var(--color-blue-primary))\n    - In the UX repo, many times there are duplicate slectors in the same file, search for duplicates and merge them together...\n    - > remember in CSS, the last declaration wins, so if there's conflicting declarations inside of duplicate selector blocks, use the last one in the file\n\n    ====================== */\n\n/* Base Button */\n.btn {\n    margin: 0;\n    border: none;\n    border-radius: 4px;\n    color: white;\n    transition: background-color 200ms, border 100ms, box-shadow 100ms;\n    cursor: pointer;\n}\n.btn:focus-visible {\n    outline: none;\n    box-shadow: 0 0 0 2px white, 0 0 0 4px var(--color-blue-primary);\n}\n\n/* Disabled Button */\n.btn[disabled],\n.btn[disabled]:hover,\n.btn[disabled]:focus {\n    cursor: not-allowed;\n    box-shadow: none;\n    opacity: .5;\n}\n\n/* Button SIZES */\n.btn.btnLarge {\n    height: 44px;\n    padding: 0 25px;\n    font-size: 16px;\n    line-height: 22px;\n}\n.btn.btnMedium {\n    height: 33px;\n    padding: 0 15px;\n    font-size: 14px;\n    line-height: 27px;\n}\n.btn.btnSmall {\n    height: 22px;\n    padding: 0 12px;\n    font-size: 11px;\n    line-height: 20px;\n}\n\n\n/* Primary Button */\n.btn.btnPrimary,\n.btn.btnPrimary[disabled]:hover,\n.btn.btnPrimary[disabled]:focus {\n    background-color: var(--color-blue-primary);\n}\n.btn.btnPrimary:hover  { background-color: var(--color-blue-dark-1); }\n.btn.btnPrimary:focus  { background-color: var(--color-blue-primary); }\n.btn.btnPrimary:active { background-color: var(--color-blue-dark-2); }\n\n\n/* Secondary Button */\n.btn.btnSecondary,\n.btn.btnSecondary[disabled]:hover,\n.btn.btnSecondary[disabled]:focus {\n    background-color: var(--color-darkui-accent-2);\n}\n.btn.btnSecondary:hover  { background-color: var(--color-darkui-accent-1); }\n.btn.btnSecondary:focus  { background-color: var(--color-darkui-accent-2); }\n.btn.btnSecondary:active { background-color: var(--color-darkui-surface-4); }\n\n\n/* Danger Button */\n.btn.btnDanger,\n.btn.btnDanger[disabled]:hover,\n.btn.btnDanger[disabled]:focus {\n    background-color: var(--color-red-primary);\n}\n.btn.btnDanger:hover  { background-color: var(--color-red-dark-1); }\n.btn.btnDanger:focus  { background-color: var(--color-red-primary); }\n.btn.btnDanger:active { background-color: var(--color-red-dark-2); }\n\n\n/* Reverse Button */\n.btn.btnReverse,\n.btn.btnReverse[disabled]:hover,\n.btn.btnReverse[disabled]:focus {\n  color: black;\n  background-color: white;\n}\n.btn.btnReverse:hover  { background-color: var(--color-lightui-surface-2); }\n.btn.btnReverse:focus  { background-color: white; }\n.btn.btnReverse:active { background-color: var(--color-lightui-surface-4); }\n\n\n/* Buttons with Icon */\n.btn [class*=\"icon-\"],\n.btn [class^=\"icon-\"]  { vertical-align: unset; }\n\n/* ICON-only Buttons */\n.btn.icon           { padding: 0 10px; }\n.btn.btnLarge.icon  { padding: 0 15px; }\n.btn.btnMedium.icon { padding: 0 10px; }\n.btn.btnSmall.icon  { padding: 0 5px; font-size: 14px; }\n\n/* Reverse Icon-only Buttons */\n.btn.btnReverse.icon:active,\n.btn.btnReverse.icon:hover { text-decoration: none; }\n\n\n/* Miscellaneous Other */\n.btn.block {\n    width: 100%;\n}\n.btn.btnFlat {\n    box-shadow: none;\n    border-radius: 2px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn": `Button_btn__g8LLk`,
	"btnLarge": `Button_btnLarge__q05Ln`,
	"btnMedium": `Button_btnMedium__Icah-`,
	"btnSmall": `Button_btnSmall__J8IWB`,
	"btnPrimary": `Button_btnPrimary__1NpC1`,
	"btnSecondary": `Button_btnSecondary__s33fj`,
	"btnDanger": `Button_btnDanger__137s7`,
	"btnReverse": `Button_btnReverse__9g22b`,
	"icon": `Button_icon__mwAN9`,
	"block": `Button_block__RTXXp`,
	"btnFlat": `Button_btnFlat__tUW3y`
};
export default ___CSS_LOADER_EXPORT___;
